import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {PredefinedFilter} from '@components/right-panel/search/search-store'
import {SearchTop} from '@components/right-panel/search/search-top'

const TwTitle = tw.div`
  flex
  items-center
  gap-16
  h-56
  py-12
`

const TwMyCompany = tw.div`
  text-sm-semibold
  text-panel-text-primary
  cursor-default
`

const availablePredefinedFilters: PredefinedFilter[] = [
  'everywhere',
  'task-titles',
  'custom'
]

export const DashboardTitle = () => {
  return (
    <TwTitle>
      <TwMyCompany>{Lang.msg.companies.myCompany}</TwMyCompany>
      <SearchTop
        defaultPredefinedFilter="everywhere"
        availablePredefinedFilters={availablePredefinedFilters}
      />
    </TwTitle>
  )
}
